import { render, staticRenderFns } from "./Forums.vue?vue&type=template&id=12433ede&"
import script from "./Forums.vue?vue&type=script&lang=js&"
export * from "./Forums.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports